<template>
  <section>
    <app-loading v-if="loading" />
    <div v-else>
      <div class="grid grid-cols-12 gap-6 mt-5">
        <div class="intro-y col-span-12 lg:col-span-12">
          <div class="intro-y box">
            <div
              class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
            >
              <h2 class="font-medium text-base mr-auto">
                Editar Tarea (Admin) - <app-title-custom />
              </h2>
              <div class="form-check w-full sm:w-auto sm:ml-auto mt-3 sm:mt-0">
                Creada por:<label
                  class="form-check-label ml-0 sm:ml-2"
                  for="show-example-1"
                >
                  {{ task.user_created_name }} - {{ task.created_at }}
                </label>
              </div>
            </div>
            <form
              class="intro-y grid grid-cols-12 gap-3 p-5 form-task"
              @submit.prevent="updateTask"
            >
              <div class="col-span-6 sm:col-span-6 xxl:col-span-12">
                <div class="mb-2">
                  <label for="msg">Nombre</label>
                  <input
                    @input="updateValue('name', $event)"
                    type="text"
                    class="input w-full border mt-2"
                    :value="task.name"
                  />
                </div>
                <label for="msg">Fecha de entrega</label>
                <input
                  @input="updateValue('date', $event)"
                  type="date"
                  class="input w-full border mt-2"
                  :value="task.date"
                />
              </div>
              <div class="col-span-6 sm:col-span-6 xxl:col-span-12">
                <label>Descripcion</label>
                <textarea
                  class="input w-full border mt-2"
                  @input="updateValue('description', $event)"
                  rows="5"
                  :value="task.description"
                ></textarea>
              </div>
              <div class="mt-3 col-span-4 sm:col-span-4 xxl:col-span-6">
                <label for="msg">Horas</label>
                <input
                  @input="updateValue('hours', $event)"
                  type="number"
                  class="input w-full border mt-2"
                  min="0"
                  max="100"
                  step=".01"
                  :value="task.hours"
                />
              </div>
              <div class="mt-3 col-span-4 sm:col-span-4 xxl:col-span-6">
                <label>Proyecto</label>
                <select
                  class="input w-full border mt-2"
                  @input="updateValue('project_id', $event)"
                  :v-model="aux_task.project_id"
                  required
                >
                  <option disabled>Seleccione...</option>
                  <option v-for="project in projects" :value="project.id">
                    {{ project.name }} - {{ project.account.name }}
                    {{ project.account.country.prefix }}
                  </option>
                </select>
              </div>
              <div class="mt-3 col-span-4 sm:col-span-4 xxl:col-span-6">
                <label>Campaña</label>
                <select
                  class="input w-full border mt-2"
                  @input="updateValue('campaign_id', $event)"
                  :value="aux_task.campaign_id"
                  required
                >
                  <option value="">Seleccione la campaña</option>
                  <option
                    v-for="campaign in filteredCampaigns"
                    :value="campaign.id"
                  >
                    {{ campaign.name }}
                  </option>
                </select>
              </div>
              <div class="mt-3 col-span-4 sm:col-span-4 xxl:col-span-6">
                <label>Equipo</label>
                <select
                  class="input w-full border mt-2"
                  @input="updateValue('team_id', $event)"
                  :value="task.team_id"
                  required
                >
                  <option disabled>Seleccione el equipo</option>
                  <option v-for="team in teams" v-bind:value="team.id">
                    {{ team.name }}
                  </option>
                </select>
              </div>
              <div class="mt-3 col-span-4 sm:col-span-4 xxl:col-span-6">
                <label for="msg">Estado</label>
                <select
                  class="input w-full border mt-2"
                  @input="updateValue('state_id', $event)"
                  :value="task.state_id"
                  required
                >
                  <option disabled>Seleccione el estado</option>
                  <option v-for="state in states" v-bind:value="state.id">
                    {{ state.name }}
                  </option>
                </select>
              </div>
              <div class="mt-3 col-span-4 sm:col-span-4 xxl:col-span-6">
                <label>Usuario</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  @input="updateValue('user_id', $event)"
                  :value="task.user_id"
                  required
                >
                  <option disabled>Seleccione el usuario</option>
                  <option v-for="user in filteredUsers" v-bind:value="user.id">
                    {{ user.name }}
                  </option>
                </select>
              </div>
              <div class="my-3 col-span-12 sm:col-span-12">
                <label>Url Archivo (opcional)</label>
                <input
                  @input="updateValue('path', $event)"
                  type="text"
                  class="input w-full border mt-2"
                  :value="task.path"
                />
              </div>
              <div
                class="col-span-12 gap-4 grid grid-cols-12 py-5 row-gap-3 sm:col-span-12"
                v-if="[4, 5, 7].includes(task.state_id)"
              >
                <div class="col-span-6 sm:col-span-6">
                  <label>Descripcion Respuesta</label>
                  <textarea
                    class="input w-full border mt-2"
                    rows="1"
                    @input="updateValue('response_observations', $event)"
                    v-model="task.response_observations"
                    required
                  ></textarea>
                </div>
                <div class="col-span-12 sm:col-span-12">
                  <label>Url Archivo Respuesta (opcional)</label>
                  <input
                    type="text"
                    class="input w-full border mt-2"
                    @input="updateValue('response_path', $event)"
                    v-model="task.response_path"
                  />
                </div>
              </div>
              <div class="mt-3 col-span-12">
                <button
                  type="submit"
                  id="edit"
                  class="button w-24 bg-theme-1 text-white"
                  :disabled="buttonIsLoading"
                >
                  <template v-if="buttonIsLoading"> Cargando... </template>
                  <template v-else> Modificar </template>
                </button>
              </div>
            </form>

            <div v-if="task.versions.length">
              <div
                class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
              >
                <h2 class="font-medium text-base mr-auto">Versiones</h2>
              </div>
              <div
                class="grid grid-cols-12 items-center p-5 border-b border-gray-200"
                v-for="version in task.versions"
              >
                <div class="col-span-6 mt-3 lg:mt-0">
                  {{ version.observations }}
                  <div class="text-gray-600 text-xs">
                    {{ version.created_at }}
                  </div>
                  <a v-if="version.path" :href="version.path" target="_blank"
                    >Abrir Url</a
                  >
                </div>
                <div
                  class="col-span-6 mt-3 lg:mt-0"
                  v-if="version.response_observations"
                >
                  {{ version.response_observations }}
                  <div class="text-gray-600 text-xs">
                    {{ version.updated_at }}
                  </div>
                  <a
                    v-if="version.response_path"
                    :href="version.response_path"
                    target="_blank"
                    >Abrir Url</a
                  >
                </div>
                <div class="col-span-6 mt-3 lg:mt-0" v-else>
                  <form
                    class="intro-y gap-3"
                    @submit.prevent="updateVersion(version)"
                  >
                    <div class="col-span-6 sm:col-span-6">
                      <label>Descripcion</label>
                      <textarea
                        class="input w-full border mt-2"
                        rows="1"
                        v-model="version_current.response_observations"
                        required
                      ></textarea>
                    </div>
                    <div class="col-span-6 sm:col-span-6">
                      <label>Url Archivo (opcional)</label>
                      <input
                        type="text"
                        class="input w-full border mt-2"
                        v-model="version_current.response_path"
                      />
                    </div>
                    <div class="mt-3 col-span-12 sm:col-span-12">
                      <button
                        type="submit"
                        id="editversion"
                        class="button bg-theme-1 text-white"
                      >
                        Responder
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <form
              class="intro-y grid grid-cols-12 gap-3 p-5 form-task"
              @submit.prevent="createVersion"
            >
              <div class="col-span-3 sm:col-span-3">
                <label>Descripcion</label>
                <textarea
                  class="input w-full border mt-2"
                  rows="1"
                  v-model="version.observations"
                  required
                ></textarea>
              </div>
              <div class="col-span-3 sm:col-span-3">
                <label>Url Archivo (opcional)</label>
                <input
                  type="text"
                  class="input w-full border mt-2"
                  v-model="version.path"
                />
              </div>
              <div class="col-span-3 sm:col-span-3">
                <label>Fecha</label>
                <input
                  type="date"
                  class="input w-full border mt-2"
                  v-model="version.date"
                />
              </div>
              <div class="mt-8 col-span-3 sm:col-span-3">
                <button
                  type="submit"
                  id="create"
                  class="button bg-theme-1 text-white"
                >
                  Crear Nueva Version
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Loading from '@/components/admin/partials/LoadingWhite'
import TitleCustom from '@/components/admin/partials/TitleCustom'

export default {
  name: 'EditTaskAdmin',
  data() {
    return {
      loading: false,
      view: {
        entity: 'task',
        id: this.$route.params.id,
      },
      version: {
        entity: 'taskversion',
        observations: '',
        path: '',
        date: '',
      },
      aux_task: {
        entity: 'task',
        campaign_id: null,
        project_id: null,
      },
      version_current: {
        entity: 'taskversion',
      },
      buttonIsLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      task: 'getTask',
      campaigns: 'getCampaigns',
      teams: 'getTeams',
      states: 'getTaskStates',
      users: 'getUsers',
      projects: 'getProjects',
    }),
    filteredCampaigns() {
      let campaigns = this.campaigns.filter((v) => {
        return v.project_id == this.aux_task.project_id
      })

      const found = campaigns.some(
        (el) => el.id == this.aux_task['campaign_id']
      )
      if (this.task && !found) {
        this.aux_task['campaign_id'] = ''
      }
      return campaigns
    },
    filteredUsers() {
      return this.users.filter((item) => {
        var accounts_ids = item.accountsIds
        var search = accounts_ids.indexOf(
          this.task.campaign_attribute.project_account_id
        )

        return search !== -1
      })
    },
  },
  async beforeMount() {
    this.loading = true
    try {
      await this.show(this.view)
      this.getList('campaign')
      this.getList('team')
      this.getList('taskstate')
      this.getList('user')
      this.getList('project')
      this.aux_task['campaign_id'] = this.task.campaign_id
      this.aux_task['project_id'] = this.task.project_id
      this.loading = false
    } catch (error) {}
  },
  methods: {
    updateTask() {
      var vm = this
      this.loadingButton = true
      window.$('#edit').button('loading')
      vm.aux_task.id = this.task.id
      vm.update(vm.aux_task)
        .then((item) => {
          vm.$router.replace('/admin/traffic/tasks')
        })
        .catch((message) => {
          window.$('#edit').button('reset')
        })
        .finally(() => {
          this.loadingButton = false
        })
    },
    createVersion() {
      var vm = this
      vm.loading = false
      window.$('#create').button('loading')
      vm.version.task_id = this.task.id
      vm.store(vm.version)
        .then((item) => {
          vm.loading = true
          vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/tasks')
        })
        .catch((message) => {
          window.$('#create').button('reset')
          vm.loading = true
        })
    },
    updateVersion(item) {
      var vm = this
      vm.loading = false
      window.$('#editversion').button('loading')
      vm.version_current.id = item.id
      vm.store(vm.version_current)
        .then((item) => {
          vm.loading = true
          vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/tasks')
        })
        .catch((message) => {
          window.$('#editversion').button('reset')
          vm.loading = true
        })
    },
    updateValue(attribute, e) {
      this.aux_task[attribute] = e.target.value
    },
    ...mapActions(['show', 'getAll', 'getList', 'update', 'store']),
  },
  components: {
    appLoading: Loading,
    appTitleCustom: TitleCustom,
  },
}
</script>



// WEBPACK FOOTER //
// EditTask.vue?2e29e2cd